<template>
  <!-- Client Section -->
  <section class="client-section client-section-about">
    <div class="container">
      <div class="overlay-img d-none d-md-block">
        <div class="overlay-img-left">
          <img src="@/assets/img/bg/transperent-circle.png" alt="img" class="img-fluid" />
        </div>
        <div class="overlay-img-right">
          <img src="@/assets/img/bg/bg-graphics.png" alt="img" class="img-fluid" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading">
            <h2>Testimonials</h2>
            <p>
              Our clients rave about our seamless service, exceptional quality, and
              unmatched customer support.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel testimonial-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in Aboutplaning" :key="item.id">
                <div class="card client-widget">
                  <div class="card-body">
                    <div class="client-img">
                      <a href="javascript:;">
                        <img
                          class="img-fluid"
                          alt="Image"
                          :src="require(`@/assets/img/user/${item.Image}`)"
                        />
                      </a>
                    </div>
                    <div class="client-content">
                      <p>{{ item.Content }}</p>
                      <h5>{{ item.Name }}</h5>
                      <h6>{{ item.Position }}</h6>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Client Section -->

  <!-- Service Section -->
  <div class="service-offer">
    <div class="container">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-7">
              <div class="service-content">
                <h6 class="display-6">Looking for the Best Service Finder & Bookings</h6>
                <p>
                  We offer a comprehensive directory of top-rated service providers,
                  detailed profiles, and customer reviews to help you make informed
                  choices.
                </p>

                <div class="d-flex">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-white d-flex align-items-center"
                    >Get Started <i class="ms-1 ti ti-circle-arrow-right"></i
                  ></a>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="service-img d-none d-md-block">
                <img src="@/assets/img/services/repair-img.png" alt="img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Service Section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import Aboutplaning from "@/assets/json/about-planning.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      Aboutplaning: Aboutplaning,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>

<style>
.client-widget {
  margin-right: 24px;
}
</style>
